module.exports = __webpack_public_path__ + "img/plan.608328df.png";